import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

// Make Pusher available globally for Echo
declare global {
  interface Window {
    Pusher: typeof Pusher
    Echo: Echo<'reverb'>
  }
}

window.Pusher = Pusher

const reverbAppKey = import.meta.env.VITE_REVERB_APP_KEY

/**
 * Laravel Echo instance configured for Reverb WebSockets.
 * Per AD-005: Real-time pipeline stage updates via Reverb.
 *
 * @see CLAUDE.md Section 20 - AD-005
 */
export const echo = reverbAppKey
  ? new Echo({
      broadcaster: 'reverb',
      key: reverbAppKey,
      wsHost: import.meta.env.VITE_REVERB_HOST,
      wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
      wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
      forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
      enabledTransports: ['ws', 'wss'],
    })
  : null

// Export for global access
if (echo) {
  window.Echo = echo
}

export default echo
